import {Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {
    simpleValueAccessorProvider,
} from '../../../util/angular/simple-value-accessor'
import {FormControl} from '@angular/forms';

export interface SelectType {
    kod: string,
    opis: string
}

@Component({
    selector: 'shared-select',
    styleUrls: ['./select.component.scss'],
    templateUrl: 'select.component.html',
    providers: [simpleValueAccessorProvider(SelectComponent)]
})
export class SelectComponent {

    @Input()
    list: SelectType[] = []

    @Input()
    domyslnyWiersz ? = 'Wybierz przyczynę'

    selectedElement = null as unknown as SelectType
    optionPanelOpen = false

    selectedValue = ''

    constructor(private eRef: ElementRef) { }

    onSelectionChange(changes: SelectType): void {
        this.selectedElement = changes;
        this.selectedValue = changes.kod
        this.propagateChange(this.selectedValue);
    }

    @HostListener('document:click', ['$event'])
    clickOut(event: { target: any; }): void {
        if (!this.eRef.nativeElement.contains(event.target) && !event.target.classList.contains('c-select__item')) {
            this.optionPanelOpen = false
        } else if (event.target.classList.contains('c-select__title')) {
            this.optionPanelOpen = !this.optionPanelOpen
        }
    }

    propagateChange = (_: any) => { }

    get value(): any {
        return this.selectedValue;
    };

    writeValue(value: any): void {
        this.selectedValue = value;
        this.selectedElement = this.list.find(i => i.kod === value) as SelectType
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void { }
}
